/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_History_RunningInputs */



/**
* | output |
* | --- |
* | "Running" |
*
* @param {Assistant_History_RunningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_history_running = /** @type {((inputs?: Assistant_History_RunningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_History_RunningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En cours d'exécution")
	if (locale === "de") return /** @type {LocalizedString} */ ("Läuft")
	if (locale === "it") return /** @type {LocalizedString} */ ("Corsa")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Бег")
	if (locale === "es") return /** @type {LocalizedString} */ ("Correr")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("跑步")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ランニング")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दौड़ना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Correndo")
	return /** @type {LocalizedString} */ ("Running")
});